module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_c('p', [_vm._v("Naam")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.titulatuur) + " " + _vm._s(_vm.voorletters) + " " + _vm._s(_vm.tussenvoegsel) + " " + _vm._s(_vm.achternaam))])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Woonadres")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.straat) + " " + _vm._s(_vm.huisnummer) + " " + _vm._s(_vm.huisnummertoevoeging)), _c('br'), _vm._v(_vm._s(_vm.postcode) + " " + _vm._s(_vm.plaats))])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Geboortedatum")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.geboortedatum))])]), _vm._v(" "), (_vm.burgerlijkestaat) ? _c('li', [_c('p', [_vm._v("Burgerlijke staat")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.burgerlijkestaat))])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Persoonsgegevens")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aef2b9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/mijngegevens/persoonsgegevens.vue
// module id = 41
// module chunks = 0